export const regionListConstants = {
  REGION_LIST_LOADING: "REGION_LIST_LOADING",
  REGION_LIST_SUCCESS: "REGION_LIST_SUCCESS",
  REGION_LIST_FAILURE: "REGION_LIST_FAILURE",
};

export const downloadVersionFileConstants = {
  DWNLD_VERSION_FILE_LOADING: "DWNLD_VERSION_FILE_LOADING",
  DWNLD_VERSION_FILE_SUCCESS: "DWNLD_VERSION_FILE_SUCCESS",
  DWNLD_VERSION_FILE_FAILURE: "DWNLD_VERSION_FILE_FAILURE",
};

export const globalReleasesConstants = {
  GLOBAL_RELEASES_LIST_LOADING: "GLOBAL_RELEASES_LIST_LOADING",
  GLOBAL_RELEASES_LIST_SUCCESS: "GLOBAL_RELEASES_LIST_SUCCESS",
  GLOBAL_RELEASES_LIST_FAILURE: "GLOBAL_RELEASES_LIST_FAILURE",
};

export const checksumAlgorthmConstants = {
  CHECKSUM_ALGORITHM_LIST_LOADING: "CHECKSUM_ALGORITHM_LIST_LOADING",
  CHECKSUM_ALGORITHM_LIST_SUCCESS: "CHECKSUM_ALGORITHM_LIST_SUCCESS",
  CHECKSUM_ALGORITHM_LIST_FAILURE: "CHECKSUM_ALGORITHM_LIST_FAILURE",
};

export const hm5GlobalReleasesConstants = {
  HM5_GLOBAL_RELEASES_LIST_LOADING: "HM5_GLOBAL_RELEASES_LIST_LOADING",
  HM5_GLOBAL_RELEASES_LIST_SUCCESS: "HM5_GLOBAL_RELEASES_LIST_SUCCESS",
  HM5_GLOBAL_RELEASES_LIST_FAILURE: "HM5_GLOBAL_RELEASES_LIST_FAILURE",
};
export const hmplusGlobalReleasesConstants = {
  HMPLUS_GLOBAL_RELEASES_LIST_LOADING: "HMPLUS_GLOBAL_RELEASES_LIST_LOADING",
  HMPLUS_GLOBAL_RELEASES_LIST_SUCCESS: "HMPLUS_GLOBAL_RELEASES_LIST_SUCCESS",
  HMPLUS_GLOBAL_RELEASES_LIST_FAILURE: "HMPLUS_GLOBAL_RELEASES_LIST_FAILURE",
};

export const uaGlobalReleasesConstants = {
  UA_GLOBAL_RELEASES_LIST_LOADING: "UA_GLOBAL_RELEASES_LIST_LOADING",
  UA_GLOBAL_RELEASES_LIST_SUCCESS: "UA_GLOBAL_RELEASES_LIST_SUCCESS",
  UA_GLOBAL_RELEASES_LIST_FAILURE: "UA_GLOBAL_RELEASES_LIST_FAILURE",
};

export const saGlobalReleasesConstants = {
  SA_GLOBAL_RELEASES_LIST_LOADING: "SA_GLOBAL_RELEASES_LIST_LOADING",
  SA_GLOBAL_RELEASES_LIST_SUCCESS: "SA_GLOBAL_RELEASES_LIST_SUCCESS",
  SA_GLOBAL_RELEASES_LIST_FAILURE: "SA_GLOBAL_RELEASES_LIST_FAILURE",
};

export const vs2jen2GlobalReleasesConstants = {
  VS2JEN2_GLOBAL_RELEASES_LIST_LOADING: "VS2JEN2_GLOBAL_RELEASES_LIST_LOADING",
  VS2JEN2_GLOBAL_RELEASES_LIST_SUCCESS: "VS2JEN2_GLOBAL_RELEASES_LIST_SUCCESS",
  VS2JEN2_GLOBAL_RELEASES_LIST_FAILURE: "VS2JEN2_GLOBAL_RELEASES_LIST_FAILURE",
};

export const vs2ngaGlobalReleasesConstants = {
  VS2NGA_GLOBAL_RELEASES_LIST_LOADING: "VS2NGA_GLOBAL_RELEASES_LIST_LOADING",
  VS2NGA_GLOBAL_RELEASES_LIST_SUCCESS: "VS2NGA_GLOBAL_RELEASES_LIST_SUCCESS",
  VS2NGA_GLOBAL_RELEASES_LIST_FAILURE: "VS2NGA_GLOBAL_RELEASES_LIST_FAILURE",
};
